import React, { FC } from "react";
import styled from "styled-components";
import { HeaderLink } from "./HeaderLink";
import { useAuthGuard } from "../../auth";
import { UserRole } from "../../../generated/graphql";
import useTranslateMessage from "../../../hooks/useTranslateMessage";
import LocaleChanger from "../../../components/LocaleChanger/LocaleChanger";

const StyledHeaderNavigation = styled.div`
  height: 100%;
  display: flex;

  & > * + * {
    margin-inline-start: 64px;
  }
`;

interface Props {}

const HeaderNavigation: FC<Props> = () => {
  const { isRole, isAllowed } = useAuthGuard([
    UserRole.CatalogManager,
    UserRole.SystemAdmin,
  ]);
  const t = useTranslateMessage();

  const isAdminRole = isRole(UserRole.SystemAdmin);
  const isOrderModeratorRole = isRole(UserRole.OrderModerator);

  return (
    <StyledHeaderNavigation>
      <LocaleChanger />
      {/* Requisition Management */}
      <HeaderLink href="/requisitions">
        {t({ id: "requisitionsview-title" })}
      </HeaderLink>
      {/* Order Management */}
      <HeaderLink href="/orders">{t({ id: "ordersview-title" })}</HeaderLink>
      {/* Reports */}
      <HeaderLink href="/reports">{t({ id: "header-reports" })}</HeaderLink>
      {/* Workflows */}
      {isAdminRole && (
        <HeaderLink href="/workflows">
          {t({ id: "header-workflows" })}
        </HeaderLink>
      )}
      {/* Companies Table */}
      {isAdminRole && (
        <HeaderLink href="/companies">
          {t({ id: "header-companies" })}
        </HeaderLink>
      )}
      {isOrderModeratorRole && (
        <>
          {/* Company settings */}
          <HeaderLink href="/my-company">
            {t({ id: "HeaderNavigation-companySettings" })}
          </HeaderLink>
          {/* Company catalog */}
          <HeaderLink href="/company-catalog">
            {t({ id: "companycatalog-171,36" })}
          </HeaderLink>
        </>
      )}
      {/* Catalog */}
      {isAllowed && (
        <HeaderLink href="/catalog">{t({ id: "header-catalog" })}</HeaderLink>
      )}
    </StyledHeaderNavigation>
  );
};

export { HeaderNavigation };
